import { defineComponent as _defineComponent } from 'vue'
import { Stoppable, useIntervalFn, useTimeoutFn } from '@vueuse/core';
import { SECOND, DAY, HOUR, MINUTE } from 'ah-common-lib/src/constants/time';
import { ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CountdownTimer',
  props: {
    targetDate: null,
    pause: { type: Boolean, default: false }
  },
  emits: ["timer-end"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'timer-end'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { targetDate: Date, pause: boolean };



const difference = ref<string[]>([]);



function updateUI() {
  let differenceDate = new Date(props.targetDate).getTime() - new Date().getTime();

  if (differenceDate >= 0) {
    let daysDifference = Math.floor(differenceDate / 1000 / 60 / 60 / 24);
    differenceDate -= daysDifference * DAY;
    let hoursDifference = Math.floor(differenceDate / 1000 / 60 / 60);
    differenceDate -= hoursDifference * HOUR;
    let minutesDifference = Math.floor(differenceDate / 1000 / 60);
    differenceDate -= minutesDifference * MINUTE;
    let secondsDifference = Math.floor(differenceDate / SECOND);

    const value = [
      daysDifference.toString(),
      hoursDifference.toString(),
      minutesDifference.toString(),
      secondsDifference.toString(),
    ].map((elem) => (elem.length === 1 ? '0' + elem : elem));

    if (value[0] === '00') {
      value.shift();
    }

    difference.value = value;
  } else {
    difference.value = ['00', '00', '00'];
  }
}

useIntervalFn(updateUI, SECOND);

let timerTimeout: Stoppable | null = null;

watch(
  () => [props.targetDate, props.pause],
  () => {
    if (timerTimeout) {
      timerTimeout.stop();
    }
    if (new Date(props.targetDate) >= new Date()) {
      timerTimeout = useTimeoutFn(() => {
        if (!props.pause) {
          emit('timer-end');
        }
      }, props.targetDate.valueOf() - Date.now());
    } else {
      if (!props.pause) {
        emit('timer-end');
      }
    }
    updateUI();
  },
  { immediate: true }
);

return { __sfc: true,props, difference, emit, updateUI, timerTimeout }
}

})